import React from "react"

export type SetNavWidth = (navWidth: number) => void

interface SideBarNavigation {
  navWidth: number,
  setNavWidth?: SetNavWidth
}

const SideBarContext = React.createContext<SideBarNavigation>({
  navWidth: 190
})

export default SideBarContext
